import {kSystemIcons} from "../../../constants/icons";
import {kSystemImages} from "../../../constants/images";
import {isNullOrUndefined} from "../../../services/Validator";

export default function NeoExerciserTopBar({ levelA, onButtonClick }) {
    // Used in NeoFlashMetaScreen to display top bar

    // BUILD
    if (isNullOrUndefined(levelA) || isNullOrUndefined(onButtonClick))
        return null
    return (
        <div className={"w-full flex justify-start items-center space-x-[16px] p-[16px]"}>
            <div className={`w-full h-[48px] min-h-[48px] flex justify-between items-center bg-primary/10 rounded-[12px] pl-[8px] pr-[16px]`}>
                <div className={"flex justify-start itms-center space-x-[8px]"}>
                    <div className={"flex justify-start items-center space-x-[10px]"}>
                        <div className={`bg-primary/30 w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center rounded-[8px]`}>
                            <i className={`material-icons text-[16px] text-primary`}>
                                {kSystemIcons.medal}
                            </i>
                        </div>
                        <span className={"font-bold text-[18px] text-white"}>
                            {"Exercice"}
                        </span>
                    </div>
                    <div className={"flex space-x-[8px] justify-start items-center text-greyLight11 font-medium"}>
                        <img className="mt-[2px]"
                             src={kSystemImages.dividerStar}
                             style={{height: 12}}
                             alt={""} />
                        <p className="text-[16px]">
                            {levelA.levelAGrade?.name}
                        </p>
                        <img className="mt-[2px]"
                             src={kSystemImages.dividerStar}
                             style={{height: 12}}
                             alt={""} />
                        <p className="text-[16px]">
                            {levelA.task}
                        </p>
                    </div>
                </div>
            </div>
            <div className="cursor-pointer h-[48px] min-h-[48px] flex justify-start items-center space-x-[8px]
                         text-greyLight7 hover:text-greyLight9 bg-backgroundLight4 hover:bg-backgroundLight5 rounded-[12px] pl-[16px] pr-[14px]
                         shadow-[inset_0_0_0_1px_#374356]"
                 onClick={onButtonClick}>
                <span className={"font-bold whitespace-nowrap text-[14px]"}>
                    {"Quitter"}
                </span>
                <i className={'material-icons text-[20px]'}>
                    {kSystemIcons.exit}
                </i>
            </div>
        </div>
    );
}